import { render, staticRenderFns } from "./addgoodsgroup.vue?vue&type=template&id=60a23cf0&scoped=true&"
import script from "./addgoodsgroup.vue?vue&type=script&lang=js&"
export * from "./addgoodsgroup.vue?vue&type=script&lang=js&"
import style0 from "./addgoodsgroup.vue?vue&type=style&index=0&id=60a23cf0&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a23cf0",
  null
  
)

export default component.exports